import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31bfb071&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bfb071')) {
      api.createRecord('31bfb071', component.options)
    } else {
      api.reload('31bfb071', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31bfb071&", function () {
      api.rerender('31bfb071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operate/backBranch/index.vue"
export default component.exports